import React, { useEffect, useRef, useState } from "react";
import call from "./Images/call.png";
import mail from "./Images/mail.png";
import adddress from "./Images/address.png";
import insta from "./Images/insta.png";
import facebook from "./Images/facebook.png";
import linkdin from "./Images/linkdin.png";
import youtube from "./Images/youtube.png";
import logo from "./Images/RMB-Strip-Jaipur.png";
import { RiArrowDownSLine } from "react-icons/ri";
import Login from "../Member Login And Register/Login";
import { MdCancel } from "react-icons/md";
import { AnimatePresence, motion } from "framer-motion";
import { FiX, FiMenu } from "react-icons/fi";
import axios from "axios";

interface datastructure{
 
  value:string,
  id:number,
  name:String,
}
const Header = () => {
    const api = process.env.REACT_APP_API_URL as string;
  const[showregister, setShowRegister] = useState(false);
  const[showlogin, setShowLogin] = useState(false);
 const[pagedata, setPagedata] = useState<datastructure[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<datastructure[]>(
          `${api}/auth/contactdata`,{
            
      });

        //console.log('contactdata data',response.data)
        setPagedata(response.data);
        //console.log("contactdata data in a array",pagedata);
      } catch (error) {
        console.error("contactdata Not Found:", error);
      }
    };

    fetchData();
  }, []);
  const registerModalRef = useRef<HTMLDivElement>(null);
  const loginModalRef = useRef<HTMLDivElement>(null);

  // Handle outside click for Express Interest Modal
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (registerModalRef.current && !registerModalRef.current.contains(event.target as Node)) {
        setShowRegister(false);
      }
    };

    if (showregister) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showregister]);

  // Handle outside click for Visitor Registration Modal
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (loginModalRef.current && !loginModalRef.current.contains(event.target as Node)) {
        setShowLogin(false);
      }
    };

    if (showlogin) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showlogin]);



  const [submenu, setShowsubmenu] = useState(false);
  const [submenu2, setShowsubmenu2] = useState(false);
  const[activemenu, setActivemenu] = useState('Home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  

  return (
    <div>
      <header className=" ">
        <div className="hidden md:flex flex-wrap justify-center  w-100 bg-[#000E3F]  items-center px-[8%] py-3">
          <div className=" flex  flex-wrap md:w-4/5 sm:w-[100%] items-center  text-[#F5F5F5] text-[13px] gap-x-8 gap-y-2 ">
           {pagedata.filter((items)=>items.name === 'number').map((items)=>(
              
                   <li className="flex   items-center ">
              <img className="w-4 h-4 mx-1.5" src={call} alt="" />
             
               <a href={`tel:${items.value}`}> <h2 >{items.value}</h2></a>
            </li>
                  
                   
            ))}
          
           {pagedata.filter((items)=>items.name === 'email').map((items)=>(
                

                      <li className="flex   items-center ">
              <img className="w-4 h-4 mx-1.5" src={mail} alt="" />
                    <a href={`mailto:${items.value}`}> <h2 >{items.value}</h2></a>
            </li>
                  
          ))}
          
          {pagedata.filter((items)=>items.name === 'address').map((items)=>(
                   
                    

                    <li className="flex   items-center ">
             <img className="w-4 h-4 mx-1.5" src={adddress} alt="" />
                     <h2 >{items.value}</h2>
            </li>
                    
          ))}
            
          </div>
          <div className="flex md:w-1/5 sm:w-[100%] md:justify-end sm:justify-start w-[100%] mt-5 md:mt-0 justify-start">
            <img className="mx-2 h-[18px] w-[18px]  cursor-pointer	" src={insta} alt="" onClick={()=>
              window.location.href="https://www.instagram.com/rotarymeansbusinessjaipur/"
            }/>
            <img className="mx-2 h-[18px] w-[18px] cursor-pointer	" src={facebook} alt="" onClick={()=>
              window.location.href="https://www.facebook.com/RMBJaipur"
            }/>
            <img className="mx-2 h-[18px] w-[18px] cursor-pointer	" src={linkdin} alt="" onClick={()=>
              window.location.href="#"
            }/>
            <img className="mx-2 h-[18px] w-[18px] cursor-pointer	" src={youtube} alt="" onClick={()=>
              window.location.href="https://www.youtube.com/channel/UCc82djijUfxVlxUEAMZlklQ"
            }/>
          </div>
        </div>
        
        <div className="bg-[#E1E8F0] px-[8%] flex flex-wrap w-full justify-between">
  <div className="w-[62%] md:w-[24%] py-5">
    <a href="/">
      <img className="lg:w-[290px] lg:h-[44px]  cursor-pointer" src={logo} alt="Logo" />
    </a>
  </div>

  {/* Mobile Menu Toggle */}
 
  <div className="lg:hidden flex items-center">
      <button
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        className="text-[#101729]"
      >
        <AnimatePresence mode="wait">
          {mobileMenuOpen ? (
            <motion.div
              key="close"
              initial={{ opacity: 0, rotate: -90, scale: 0.5 }}
              animate={{ opacity: 1, rotate: 0, scale: 1 }}
              exit={{ opacity: 0, rotate: 90, scale: 0.5 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <FiX className="w-8 h-8" />
            </motion.div>
          ) : (
            <motion.div
              key="menu"
              initial={{ opacity: 0, rotate: 90, scale: 0.5 }}
              animate={{ opacity: 1, rotate: 0, scale: 1 }}
              exit={{ opacity: 0, rotate: -90, scale: 0.5 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <FiMenu className="w-8 h-8" />
            </motion.div>
          )}
        </AnimatePresence>
      </button>
    </div>

  <div className="hidden lg:flex items-center justify-between pl-5 w-[56%]">
    <nav className="w-full">
      <ul className="flex justify-between items-center h-full">
        {/* Menu Items */}
        {['Home', 'About', 'Members', 'Meetings', 'Directors', 'Contact'].map((item, idx) => (
          <li
            key={idx}
            className={`hover:border-b-[3px] hover:border-[#FDBC12] active:border-b-[3px] active: hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer ${activemenu === item ? 'border-[#FDBC12]' : ''}`}
            onClick={() => {
              setActivemenu(item);
              item === 'About' && setShowsubmenu(!submenu);
              item === 'Directors' && setShowsubmenu2(!submenu2);
            }}
          >         
                    {item === 'About' || item === 'Directors'? (
                   <span className="flex items-center">
                  <a href="#" className="text-[#101729]">{item}</a>
                  <RiArrowDownSLine className="ml-2" />
              </span>
          ) : (
              <a href={`/${item.toLowerCase()}`}>
                  {item === 'Contact' ? 'Contact Us' : item}
              </a>
          )}

            
          </li>
        ))}
      </ul>
      {submenu &&  (
        
        <ul className="lg:absolute bg-[#E1E8F0] flex flex-col h-[100px] w-[191px] z-50 justify-between items-center top-[15%] lg:left-[33%] left-[7%]">
          <li className="hover:border-b-[3px] hover:border-[#FDBC12] active:border-b-[3px] active:border-[#FDBC12] hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer">
            <a href="/about">About RMB</a>
          </li>
          <li className="hover:border-b-[3px] hover:border-[#FDBC12] hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer">
            <a href="/rmbjaipur">RMB Jaipur</a>
          </li>
        </ul>
      )}
      {submenu2 && (
        <ul className="lg:absolute bg-[#E1E8F0] flex flex-col h-[187px] w-[231px] z-50 justify-around items-center top-[15%] lg:left-[58%] left-[7%]">
          <li className="hover:border-b-[3px] hover:border-[#FDBC12] active:border-b-[3px] active:border-[#FDBC12] hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer">
            <a href="/leadership">RMB Jaipur Leadership Team</a>
          </li>
          <li className="hover:border-b-[3px] hover:border-[#FDBC12] hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer">
            <a href="/rmbleaders">RMBF Leaders</a>
          </li>
          <li className="hover:border-b-[3px] hover:border-[#FDBC12] hover:text-[#101729] text-[#101729] h-full flex items-center cursor-pointer">
            <a href="#">Co-ordinator Team</a>
          </li>
          

        </ul>
      )}
    </nav>
  </div>

  {/* Registration/Login Buttons */}
  <div className="hidden lg:flex pl-8 gap-x-4 w-[20%] py-5 justify-end">
    
    <button className="bg-[#02256D] rounded w-[110px] text-[#F1F4F9] font-[16px]"
    
    onClick={()=>{window.location.href='/login'}}>Log In</button>
   
  </div>
  
  {/* Mobile Menu */}
  {mobileMenuOpen && (
  <div className="lg:hidden fixed top-0 left-0 h-full w-full bg-[#000e3f] py-4 z-100 p-4">
    <div className="lg:hidden flex items-center absolute z-[1000000] rounded top-3 w-9 h-9 justify-center right-4 bg-[#1e2c65]">
      <button
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        className="text-[#f1f4f6]"
      >
        <AnimatePresence mode="wait">
          {mobileMenuOpen ? (
            <motion.div
              key="close"
              initial={{ opacity: 0, rotate: -90, scale: 0.5 }}
              animate={{ opacity: 1, rotate: 0, scale: 1 }}
              exit={{ opacity: 0, rotate: 90, scale: 0.5 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <FiX className="w-6 h-6 !text-sm" />
            </motion.div>
          ) : (
            <motion.div
              key="menu"
              initial={{ opacity: 0, rotate: 90, scale: 0.5 }}
              animate={{ opacity: 1, rotate: 0, scale: 1 }}
              exit={{ opacity: 0, rotate: -90, scale: 0.5 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <FiMenu className="w-8 h-8" />
            </motion.div>
          )}
        </AnimatePresence>
      </button>
    </div>
  <AnimatePresence>
    {mobileMenuOpen && (
      <motion.div
    initial={{ x: -300, opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    exit={{ x: -300, opacity: 0 }}
    transition={{ duration: 0.5, ease: "easeInOut" }}
    className="flex flex-col h-screen py-4 mt-1 z-50 "
  >
    {/* Scrollable Menu */}
    <div className="flex-1 overflow-y-auto">
      <ul className="flex flex-col items-center mt-3 px-4">
          <motion.li
            whileHover={{ scale: 1.05 }}
            className={`w-full cursor-pointer `}
            onClick={() => setActivemenu('Home')}
          >
            <a href="/" className="block py-2 text-slate-200  text-lg">Home</a>
          </motion.li>

          {/* About Us with Submenu */}
          <li
            className="w-full cursor-pointer"
            onClick={() => {
              setShowsubmenu(!submenu);
              setActivemenu('About');
            }}
          >
            <div className="flex justify-between items-center py-2 text-slate-200  text-lg ">
              About Us
              <motion.div
                animate={{ rotate: submenu ? 180 : 0 }}
                transition={{ duration: 0.3 }}
              >
                <RiArrowDownSLine className="ml-2" />
              </motion.div>
            </div>
            <AnimatePresence>
              {submenu && (
                <motion.ul
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                  className=" flex flex-col w-full pl-4 space-y-1"
                >
                  <li><a href="/about" className="block py-2 text-slate-200 ">About RMB</a></li>
                  
                  <li><a href="/rmbjaipur" className="block py-2 text-slate-200 ">RMB Jaipur</a></li>
                </motion.ul>
              )}
            </AnimatePresence>
          </li>

          {/* Members */}
          <motion.li
            whileHover={{ scale: 1.05 }}
            className={`w-full cursor-pointer ${activemenu === 'Members' ? 'border-b-[3px] border-[#FDBC12]' : ''}`}
            onClick={() => setActivemenu('Members')}
          >
            <a href="/members" className="block py-2 text-slate-200 ">Members</a>
          </motion.li>

          {/* Meetings */}
          <motion.li
            whileHover={{ scale: 1.05 }}
            className={`w-full cursor-pointer `}
            onClick={() => setActivemenu('Meetings')}
          >
            <a href="/meetings" className="block py-2 text-slate-200 ">Meetings</a>
          </motion.li>

          {/* Directors with Submenu */}
          <li
            className="w-full cursor-pointer"
            onClick={() => {
              setShowsubmenu2(!submenu2);
              setActivemenu('Directors');
            }}
          >
            <div className="flex justify-between items-center py-2 text-slate-200  text-lg">
              Directors
              <motion.div
                animate={{ rotate: submenu2 ? 180 : 0 }}
                transition={{ duration: 0.3 }}
              >
                <RiArrowDownSLine className="ml-2" />
              </motion.div>
            </div>
            <AnimatePresence>
              {submenu2 && (
                <motion.ul
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                  className=" flex flex-col w-full pl-4 space-y-1"
                >
                  <li><a href="/leadership" className="block py-2 text-slate-200">RMB Jaipur Leadership Team</a></li>
                  <li><a href="/rmbleaders" className="block py-2 text-slate-200 ">RMBF Leaders</a></li>
                  <li><a href="#" className="block py-2 text-slate-200 ">Co-ordinator Team</a></li>
                </motion.ul>
              )}
            </AnimatePresence>
          </li>

          {/* Contact Us */}
          <motion.li
            whileHover={{ scale: 1.05 }}
            className={`w-full cursor-pointer `}
            onClick={() => setActivemenu('Contact')}
          >
            <a href="/contact" className="block py-2 text-slate-200 ">Contact Us</a>
          </motion.li>
        </ul>
        </div>
         
        

        {/* Log In Button */}
        <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="border-t border-slate-600 px-4 pt-4 pb-6"
    >
      {/* Contact Info */}
      <div className="text-[#F5F5F5] text-left text-sm">
        <ul>
          <li className="flex items-center space-x-2">
            <img className="w-4 h-4" src={call} alt="Phone" />
            <span>+91 9214001400</span>
          </li>
          <li className="flex items-center space-x-2 mt-3">
            <img className="w-4 h-4" src={mail} alt="Email" />
            <span>rotarymeansbuisnessjaipur@gmail.com</span>
          </li>
          <li className="flex items-center space-x-2 mt-3">
            <img className="w-4 h-4" src={adddress} alt="Address" />
            <span>209- A, Windsor Plaza, Sansar Chandra Road, Jaipur-30201</span>
          </li>
        </ul>
      </div>

      {/* Social Media */}
      <div className="flex justify-start space-x-6 py-4">
        <img className="h-7 w-7 cursor-pointer" src={insta} onClick={() => window.location.href="https://www.instagram.com/rotarymeansbusinessjaipur/"} />
        <img className="h-7 w-7 cursor-pointer" src={facebook} onClick={() => window.location.href="https://www.facebook.com/RMBJaipur"} />
        <img className="h-7 w-7 cursor-pointer" src={linkdin} onClick={() => window.location.href="#"} />
        <img className="h-7 w-7 cursor-pointer" src={youtube} onClick={() => window.location.href="https://www.youtube.com/channel/UCc82djijUfxVlxUEAMZlklQ"} />
      </div>

      {/* Login Button */}
      <button
        className="bg-[#f1f4f9] rounded w-full h-[45px] text-darkblue font-semibold"
        onClick={() => (window.location.href = "/login")}
      >
        Log In
      </button>
    </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
</div>

)}

</div>

      </header>
    </div>
  );
};


export default Header;





